import PropTypes from 'prop-types';
import { Grid } from '@mui/material';

// Our Components
import Dropdown from 'components/Dropdown/Dropdown';

// Our PropTypes
import CommonPropTypes from 'shared/prop-types';

// Utility function
const createTenureRange = () => {
	const numbers = [];
	// eslint-disable-next-line no-plusplus
	for (let num = 0; num <= 40; num++) {
		numbers.push(`${num}`);
	}
	return numbers;
};

// CONSTANTS
const TENURE_RANGE = createTenureRange();

function TenureDropdown({
	dropDownSX,
	dropDownLabelSX,
	label,
	tenure,
	setTenure,
	tabIndex,
	gridColumns,
	sx
}) {
	return (
		<Grid item xs={gridColumns} sx={{ marginBottom: 4, ...sx }}>
			<Dropdown
				helperText="Length of loan in years."
				items={TENURE_RANGE}
				label={label}
				labelSx={dropDownLabelSX}
				onChange={setTenure}
				selected={tenure}
				sx={dropDownSX}
				variant="outlined"
				tabIndex={tabIndex}
			/>
		</Grid>
	);
}

TenureDropdown.propTypes = {
	dropDownSX: CommonPropTypes.sx,
	dropDownLabelSX: CommonPropTypes.sx,
	setTenure: PropTypes.func.isRequired,
	tenure: PropTypes.string.isRequired,
	tabIndex: PropTypes.string,
	label: PropTypes.string,
	gridColumns: PropTypes.number,
	sx: CommonPropTypes.sx
};

TenureDropdown.defaultProps = {
	tabIndex: '',
	dropDownLabelSX: {},
	dropDownSX: {},
	gridColumns: 6,
	label: 'Loan length',
	sx: {}
};

export default TenureDropdown;
